import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myNewsEnabledState = atom({
  key: "myNewsEnabledState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
